import React from "react";
import { Box } from "@mui/material";
import ProjectGroupActions from "./ProjectGroupActions";
import ProjectNumberLabel from "../../../../shared/ProjectCardFrame/ProjectNumberLabel";

/**
 * グループのヘッダー
 * スマホ：
 *   項番、グループ解除ボタン
 *
 * PC：
 *   グループ解除ボタンのみ
 */
export default function ProjectGroupHeader({
  group,
  displayIndex,
  processing,
  onUngroup,
  isDesktop,
  isGrouped,
}) {
  // 単体案件（スマホのみ項番表示）
  if (!isGrouped) {
    if (!isDesktop) {
      return <ProjectNumberLabel index={displayIndex} />;
    }

    return null;
  }

  // スマホ
  if (!isDesktop) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          width: "100%",
        }}
      >
        <ProjectNumberLabel index={displayIndex} />
        <ProjectGroupActions
          groupId={group.groupId}
          processing={processing}
          onUngroup={onUngroup}
        />
      </Box>
    );
  }

  // PC
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
      }}
    >
      <ProjectGroupActions
        groupId={group.groupId}
        processing={processing}
        onUngroup={onUngroup}
      />
    </Box>
  );
}
